module.exports = __webpack_public_path__ + "img/sy.95914fac.svg";